import { createContext, useContext, useState } from 'react'
import { supabase } from '../supabase/client';

export const ProfessionalContext = createContext();

export const useProfessional = () => {
    const context = useContext(ProfessionalContext);
    if (!context) {
        throw new Error('useProfessional debe estar dentro del proveedor ProfessionalContext')
    }
    return context;
};

export const ProfessionalContextProvider = ({ children }) => {
    const [professionals, setProfessionals] = useState([])
    const [locations, setLocations] = useState([])
    const [typeLocations, setTypeLocations] = useState([])
    const [specialtiesCheck, setSpecialtiesCheck] = useState([])
    const [loading, setLoading] = useState(false)
    const [modal, setModal] = useState(false)

    const getModal = () => {
        setModal(false)
    }

    const getProfessionals = async () => {
        const { error, data } = await supabase
            .from('professionals')
            .select()
            .order('last_name', { ascending: true })
        if (error) throw (error.message)
        setProfessionals(data)
    }

    const getProfessional = async (id) => {
        const { error, data } = await supabase
            .from('professionals')
            .select()
            .eq('id', id)
            .single()
        if (error) throw (error.message)
        return data
    }

    const getProfessionalSpecialty = async (id) => {
        const { error, data, status } = await supabase
            .from('professionals_has_specialties')
            .select('specialties_id')
            .eq('professionals_id', id)
        if (error) return { error: error, code: status }
        const arrChecks = []
        data.map((item) => {
            return arrChecks.push(item.specialties_id)
        })
        setSpecialtiesCheck(arrChecks)
    }

    const getLocations = async () => {
        const { error, data } = await supabase.from('locations').select()
        if (error) throw (error.message)
        setLocations(data)
    }

    const getTypeLocations = async () => {
        const { error, data } = await supabase.from('type_locations').select()
        if (error) throw (error.message)
        setTypeLocations(data)
    }

    const createProfessional = async (formData) => {
        const { data, error, status, statusText } = await supabase
            .from('professionals')
            .insert(formData)
            .select()
        if (status !== 201) return {
            title: statusText,
            msg: error.message + " Code:[" + error.code + "]",
            icon: 'error',
            code: status
        }
        getProfessionals()
        setModal(true)
        return {
            last_id: data[0].id,
            title: statusText,
            msg: "Registro creado correctamente",
            icon: 'success',
            code: status
        }
    }

    const createProfessionalHasSpecialties = async (specialitiesData) => {
        const { error, status, statusText } = await supabase
            .from('professionals_has_specialties')
            .insert(specialitiesData)
            .select()
        if (status !== 201) return {
            title: statusText,
            msg: error.message + " Code:[" + error.code + "]",
            icon: 'error',
            code: status
        }
        getProfessionals()
        setModal(true)
        return {
            title: statusText,
            msg: "Registro creado correctamente",
            icon: 'success',
            code: status
        }
    }

    const updateProfessional = async (formData, id) => {
        try {
            const { error, status, statusText } = await supabase
                .from('professionals')
                .update(formData)
                .eq('id', id)
                .select()

            if (status !== 200) return {
                title: statusText,
                msg: error.message + " Code:[" + error.code + "]",
                icon: 'error'
            }
            getProfessionals()
            setModal(true)
            return ({
                title: statusText,
                msg: 'Registro actualizado correctamente',
                icon: 'success'
            })
        } catch (e) {
            console.error(e)
        }
    }

    const deleteProfessionalHasSpecialties = async (id) => {
        try {
            const { error, status } = await supabase
                .from('professionals_has_specialties')
                .delete()
                .eq('professionals_id', id)

            if (error) return { status: status }
            return { status: status }
        } catch (e) {
            console.error(e)
        }
    }

    const uploadFiles = async (file, path, uuid) => {
        setLoading(true)
        const { data, error } = await supabase
            .storage
            .from('files')
            .upload(`${path}/${uuid}`, file)
        if (error) return {
            title: "Error",
            msg: error.message,
            icon: 'error'
        }
        setLoading(false)
        return {data: data, error: error}
    }

    const deleteFiles = async (path, nameFile) => {
        const { data, error } = await supabase
            .storage
            .from('files')
            .remove([`${path}/${nameFile}`])
        if (error) return {
            title: "Error",
            msg: error.message,
            icon: 'error'
        }
        return data
    }

    return (
        <ProfessionalContext.Provider value={{
            modal,
            professionals,
            locations,
            typeLocations,
            specialtiesCheck,
            loading,
            getProfessionals,
            getProfessional,
            getLocations,
            getTypeLocations,
            getProfessionalSpecialty,
            getModal,
            createProfessional,
            createProfessionalHasSpecialties,
            updateProfessional,
            deleteProfessionalHasSpecialties,
            uploadFiles,
            deleteFiles,
        }}>
            {children}
        </ProfessionalContext.Provider>
    )
}